/**
 * Fonction de filtre permettant d'obtenir les valeurs uniques d'une liste
 * @param value la valeur de l'élémeent courant injecté par la fonction filter
 * @param index l'index de l'élément courant injecté par la fonction filter
 * @param array le tableau des éléments parcourus, injecté par la fonction filter
 * @returns true ssi l'élément courant est unique ou le premier parmi ses doublons dans la liste
 */
function filterUnique<T>(value: T, index: number, array: T[]): boolean {
  return array.indexOf(value) === index;
}

export { filterUnique }